// extracted by mini-css-extract-plugin
export default {"component":"Card2_component__LrTj-"};